import * as React from 'react';

type IconProps = {
    className?: string;
    size?: number;
    title?: string;
    onClick?: () => void;
};

export const MoonIcon: React.FC<IconProps> = ({ className, size = 14, title, onClick }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        onClick={onClick}
    >
        {title ? <title>{title}</title> : null}
        <path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401" />
    </svg>
);
